// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-users-modal[data-v-cdaa73be]{border-radius:15px}@media(max-width:767px)and (min-width:601px){.edit-users-modal__input-email[data-v-cdaa73be]{max-width:80%}}[data-v-cdaa73be] .v-input__slot{align-items:start}[data-v-cdaa73be] .v-input--checkbox .v-label{margin-top:3px}", ""]);
// Exports
module.exports = exports;
